import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Products from './components/Products';

const products = (props,{ t }) => (
  <Container>
    <Products {...props} />
  </Container>
);

products.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(products);
